import { useSnackbar } from '../../../../../global/config/useSnackbar';
import { useEndpointFetch } from '../../../../../global/network/useEndpointFetch';

type ChatSettingsPayload = {
  chatEnabled: boolean;
  chatAutoChannelProgram: boolean;
  chatAutoChannelActivity: boolean;
  chatAutoChannelRole: boolean;
};

const useSaveChatSettings = () => {
  return useEndpointFetch<ChatSettingsPayload>(`/tm/config/chat-settings`);
};

export const useAdminConsoleChatActions = () => {
  const saveChatSettings = useSaveChatSettings();
  const { setSnackbar } = useSnackbar();

  const runSaveChatSettings = (payload: ChatSettingsPayload & { handleSuccess?: () => void }) => {
    const { handleSuccess, ...settings } = payload;
    return saveChatSettings
      .run(settings)
      .then((res) => {
        if (!res.ok) {
          setSnackbar({ open: true, variant: 'error', message: 'Unable to update chat settings' });
          return;
        }
        setSnackbar({ open: true, variant: 'success', message: 'Chat settings updated successfully' });
        if (handleSuccess) handleSuccess();
      })
      .catch(() =>
        setSnackbar({ open: true, variant: 'error', message: 'Unable to update chat settings' })
      );
  };

  return {
    runSaveChatSettings,
    runSaveChatSettingsLoading: saveChatSettings.isLoading,
  };
};
